export const apiUrl = process.env.USER_MANAGEMENT.API_URL;

export const requestHeaders = {
  'X-Healthy-Client-Id': process.env.USER_MANAGEMENT.CLIENT_ID,
  'X-Healthy-Client-Secret': process.env.USER_MANAGEMENT.CLIENT_SECRET,
  'content-type': 'application/json',
};
